<template>
    <div class="bg-white rounded shadow-sm py-3 my-2">
        <form class="kt-form" @submit.prevent="update" id="recharge_open_banking_wallet_manually_form">
            <div class="d-flex align-items-center px-3">
                <div class="mr-auto d-flex align-items-center ">
                    <i class="fas fa-wallet text-primary"></i>
                    <div class="mx-2">{{ $t("open_banking_wallet.title") }}</div>
                </div>
            </div>
            <hr/>
            <kt-form-section is_first>
                <kt-form-row>
                    <kt-col xs="6">
                        <kt-form-group>
                            <kt-form-label for="open_banking_wallet_balance">
                                {{ $t('open_banking_wallet.recharge_wallet_manually') }}
                            </kt-form-label>
                            <kt-form-control dir="rtl" name="open_banking_wallet_balance" id="open_banking_wallet_balance"
                                             v-model="user.open_banking_wallet_balance" placeholder="مقدار افزایش"
                                             type="number"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col>
                        <div style="margin-top: 27px;" class="ml-auto">
                            <kt-form-action class="mt-4">
                                <button class="btn btn-md btn-success btn-wide" type="submit"
                                        id="recharge_open_banking_wallet_manually_submit_btn">
                                    {{ $t('btn.submit_changes') }}
                                </button>
                            </kt-form-action>
                        </div>
                    </kt-col>
                </kt-form-row>
            </kt-form-section>
        </form>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {openBankingWalletService} from "@/common/api.service";


export default {
    name: "ChargeOpenBankingWalletManually",
    computed: {
        ...mapGetters('user', [
            'user'
        ])
    },
    data() {
        return {
        };
    },
    methods: {
        update(e) {
            let form = $('#recharge_open_banking_wallet_manually_form')
            let btn = $('#recharge_open_banking_wallet_manually_submit_btn')

            form.validate({

                rules: {
                    open_banking_wallet_balance: {
                        required: true,
                    },
                },
            });

            if (!form.valid()) {
                return
            }

            let params = {
                wallet_balance: this.user.open_banking_wallet_balance,
                hashid: this.user.id,
            }

            KTApp.progress(btn)

            openBankingWalletService.rechargeWalletManually(params)
                    .then(response => {
                        this.showMsg(form, 'success', response.data.message)
                    }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
};
</script>
<style scoped>

</style>